import { useEffect, useMemo } from 'react';
import { useSettings } from '../../core/contexts/SettingsContext';
import localApiAdapter from '../../core/services/localApiAdapter';
import {
  normalizeTimeTrackingConfig,
  SAUDI_DEFAULT_TIMETRACKING_CONFIG,
} from './pointageHelpers';

let hydratePromise = null;

function isTimeTrackingConfigHydrated(timeTracking) {
  return timeTracking?._syncedFromApi === true;
}

function hydrateTimeTrackingConfig(patchSettings) {
  if (!hydratePromise) {
    hydratePromise = localApiAdapter
      .get('/timetracking/config')
      .then((response) => {
        const raw = response?.config !== undefined ? response.config : response;
        const normalized = normalizeTimeTrackingConfig(raw || {});
        syncTimeTrackingConfigToSettings(normalized, patchSettings);
        return normalized;
      })
      .catch(() => {
        hydratePromise = null;
        return { ...SAUDI_DEFAULT_TIMETRACKING_CONFIG };
      });
  }
  return hydratePromise;
}

/** Live pointage module config — synced from API once, then from SettingsContext. */
export function useTimeTrackingConfig() {
  const { settings, patchSettings } = useSettings();

  useEffect(() => {
    if (isTimeTrackingConfigHydrated(settings?.timeTracking)) return;
    void hydrateTimeTrackingConfig(patchSettings);
  }, [settings?.timeTracking, patchSettings]);

  return useMemo(
    () => normalizeTimeTrackingConfig(settings?.timeTracking || {}),
    [settings?.timeTracking],
  );
}

export function syncTimeTrackingConfigToSettings(config, patchSettings) {
  const normalized = normalizeTimeTrackingConfig(config);
  patchSettings({ timeTracking: { ...normalized, _syncedFromApi: true } }, { persist: false });
  return normalized;
}
